// BtsProduct.model.js
import { useState } from 'react';

const btsProductModel = () => {
  const initialState = {
    id: 0,
    btsProductId: 0,
    schoolProposalId: 0,
    btsClassId: 0,
    className: '',
    quantity: 1,
    price: 0,
    sequenceNumber: 0,
    header: '',
    gp: 0,
    exSell: 0,
    incSell: 0,
    itemCode: '',
    description: '',
    unit: '',
    avgCost: 0,
    normalPrice: 0,
    conversionFactor: 0,
    totalExSell: 0,
  };
  const [btsProduct, setBtsProduct] = useState(initialState);

  const resetBtsProduct = () => {
    setBtsProduct(initialState);
  };

  return { btsProduct, setBtsProduct, resetBtsProduct, initialState };
};

export default btsProductModel;
